import React, { Component } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import DocViewer from "src/pages/hr/HRUtilities/DocViewer/DocViewer"
import IconBuilder from "src/utilities/iconBuilder/IconBuilder"
import mutator from "src/utilities/mutator"
import ReviewTimelineTypes from "../ReviewTypes/ReviewTimelineTypes"
import "./DocCarousel.css"

interface Props {
    timelineItems: Array<ReviewTimelineTypes>
    manageParentState: Function
}

interface DocCarouselState {
    openItem: ReviewTimelineTypes | null
    items: Array<ReviewTimelineTypes>
}

class DocCarousel extends Component<Props, DocCarouselState> {

    storageLocation = process.env.REACT_APP_REVIEWS_STORAGE_LOCATION || ""
    containerName = process.env.REACT_APP_REVIEWS_CONTAINER_NAME || ""

    state = {
        openItem: null,
        items: []
    }

    componentDidMount(): void {
        this.filterItems(this.props.timelineItems)
    }

    componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
        if (this.props !== nextProps) {
            this.filterItems(this.props.timelineItems)
        }
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    filterItems = (timelineItems: Array<ReviewTimelineTypes>) => {
        let items = []
        for (let i = 0; i < timelineItems.length; i++) {
            if (timelineItems[i].EmployeeReviewTimelineTypeId === 1) {
                items.push(timelineItems[i])
            }
        }
        this.manageState([{ key: "items", value: items.reverse() }])
    }

    getFileTitle = (title: string | null) => {
        if (title) {
            let arr = title.split("_")
            return arr.slice(1, -1).join("_")
        }
        return "NA"
    }

    render() {

        const props = this.props
        const state = this.state
        const openItem = state.openItem
        const tooltipText = state.items.length > 1 ? "Open timeline" : "View file"

        // //console.log("DocCarousel props", props)
        // //console.log("DocCarousel state", state)

        const docViewerTooltip = (text: string) => (
            <Tooltip id="employee-review-tool-tip">
                {text}
            </Tooltip>
        )

        return (
            <div className="DocCarousel">
                <OverlayTrigger placement="top" overlay={docViewerTooltip(tooltipText)}>
                    <div className="DocCarouselPreviewItem">
                        {state.items.length === 1 && <div className="DocCarouselPreviewItemSingleItem" onClick={() => this.manageState([{ key: "openItem", value: state.items[0] }])}>
                            {/*@ts-ignore*/}
                            <IconBuilder extension={state.items[0].extension} size={48} />
                            {/*@ts-ignore*/}
                            <p>{state.items[0].TimelineTitle}</p>
                        </div>}
                        {state.items.length > 1 && <div className="DocCarouselPreviewItemMultipleItems" onClick={() => props.manageParentState([{ key: "largeTimeline", value: true }])}>
                            <div className="DocCarouselPreviewItemMultipleItemsLeft">
                                {/*@ts-ignore*/}
                                {state.items.length > 1 && <IconBuilder extension={state.items[0].extension} size={24} />}
                                <p>{`1 of ${state.items.length}`}</p>
                            </div>
                            <div className="DocCarouselPreviewItemMultipleItemsRight">
                                {/*@ts-ignore*/}
                                <p>{state.items[0].TimelineTitle}</p>
                            </div>
                        </div>}
                    </div>
                </OverlayTrigger>
                {openItem && <DocViewer
                    //@ts-ignore
                    extension={openItem.extension}
                    //@ts-ignore
                    fileName={openItem.FileName}
                    toggleDocViewer={() => this.manageState([{ key: "openItem", value: null }])}
                    getFileTitle={this.getFileTitle}
                    //@ts-ignore
                    displayName={openItem.TimelineTitle}
                    containerName={this.containerName}
                    storageLocation={this.storageLocation}
                />}
            </div>
        )
    }
}

export default DocCarousel